
import mosqueBg from '../../assets/mosque.png';


function Home() {
  return (
    <section
      id="home"
      className="min-h-[90vh] md:min-h-screen flex items-center justify-center relative text-white bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.2)), url(${mosqueBg})`
      }}
    >
      <div className="absolute top-0 w-full p-6 flex justify-between items-center z-10">
         {/* Simple elegant branding header placeholder */}
         <div className="text-white font-serif italic text-xl tracking-wider">iUnity Fundraiser</div>
      </div>
      
      <div className="w-full max-w-7xl mx-auto px-6 md:px-12 text-center md:text-left z-10">
        <div className="max-w-3xl animate-fade-in relative">
          <p className="text-sm md:text-base font-sans tracking-widest uppercase mb-4 text-white/80">
            Build your home in Jannah
          </p>
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-serif text-white mb-6 leading-tight drop-shadow-lg">
            Building Unity,
            <br />
            <span className="italic text-white/90">One Brick</span> at a Time
          </h1>
          <p className="text-lg md:text-xl font-sans text-white/80 max-w-2xl leading-relaxed drop-shadow-md">
            Join us in building a transformational center and prayer space for Muslims.
          </p>
          
          <div className="mt-12">
            <button 
              onClick={() => document.getElementById('donation').scrollIntoView({ behavior: 'smooth' })}
              className="bg-white text-gray-900 border-none rounded-sm px-8 py-4 font-sans uppercase tracking-wider text-sm hover:bg-gray-100 transition-colors cursor-pointer inline-flex items-center gap-2"
            >
              Donate Now
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Home;
